import PropTypes from 'prop-types';
import React from "react";
import reactT from './../../components/reactT';

class FederatedSortMenu extends React.Component {
  constructor(props) {
    super(props);

    // Change the default sort option based on search type.
    const defaultSortDate = ['event', 'news', 'publication'];
    let defaultSort = 'score';
    if (typeof drupalSettings !== 'undefined') {
      defaultSort = 'score';
      /*global drupalSettings:true*/
      if (defaultSortDate.indexOf(drupalSettings.type) > -1) {
        if (drupalSettings.type === 'event') {
          defaultSort = 'ds_field_date';
        }
        else {
          defaultSort = 'ds_created';
        }
      }
    }
    this.state = {
      expanded: false,
      sort: defaultSort
    };
    this.onSelect = this.onSelect.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  }

  onSelect(e) {
    this.setState({ sort: e.target.value });
  }

  onSelect(event) {
    this.setState({ sort: event.target.value });

    const sortField = event.target.value;
    const foundIdx = this.props.sortFields.indexOf(sortField);
    if (foundIdx < 0) {
      this.props.onChange(sortField, "desc");
    } else {
      this.props.onChange(sortField, null);
    }
  }

  render() {
    const { sortFields } = this.props;
    const { expanded, sort } = this.state; // Add this line to access state properties

    if (sortFields.length === 0) { return null; }
    if (this.props.mobile == 'true') {
      return (
        <div className="form-item-sort-by mobile-form-item-sort-by">
          <label htmlFor="sort-by" className={`search-accordion__title ${expanded ? 'js-search-accordion-open' : ''}`} onClick={this.toggleExpand}>{reactT('Sort by')}</label>
          {expanded &&
            <div className="" id="sort-by" name="sort-by">
              {sortFields.map((sortField, i) => (
                <div key={i} className='mobile-sort-by d-flex'>
                  <input type="radio" id={sortField.field} name="sort-by" value={sortField.field} onChange={this.onSelect} checked={sort === sortField.field} />
                  <label htmlFor={sortField.field}>{sortField.label}</label>
                </div>
              ))}
            </div>
          }
        </div>
      );
    }
    return (
      <div className="form-item-sort-by">
        <label htmlFor="sort-by">{reactT('Sort by')}</label>
        <select className="form-control" id="sort-by" name="sort-by" onChange={this.onSelect} value={this.state.sort}>
          {sortFields.map((sortField, i) => (
            <option value={sortField.field} key={i}>{sortField.label}</option>
          ))}
        </select>
      </div>
    );
  }
}

FederatedSortMenu.propTypes = {
  bootstrapCss: PropTypes.bool,
  onChange: PropTypes.func,
  sortFields: PropTypes.array
};

export default FederatedSortMenu;
